import { AddSGBPCategoryData } from "../../ViewApproveCategoryCriteria/data/AddSGBPCategory.Data";
import { ApproveSGBPCategoryCriteriaData } from "../data/ApproveSGBPCategoryCriteriaData";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "searchByCriteriaName":filterDropDownList("Criteria Code"),
        "statusId": filterDropDownList("Requirement Section Status"),
        "categoryId": filterDropDownList("L1"),
        "subCategoryId": filterDropDownList("L2"),
        "typeId": filterDropDownList("L3"),
        "channel": filterDropDownList("Channel"),
        "category": filterDropDownList("L1"),
        "subCategory": filterDropDownList("L2"),
        "type": filterDropDownList("L3"),
        "code": filterDropDownList("Criteria Code"),
        "certificateTemplate": filterDropDownList("Certificate Template"),
    };

    const formFields = [...ApproveSGBPCategoryCriteriaData.formFields,...AddSGBPCategoryData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};